import { BLOCK_TYPE } from "app/blocks/block.types";
import getAnchorIdentifier from "blocks/helpers/getAnchorIdentifier";
import { AnchorMenuLink } from "components/AnchorMenu/AnchorMenuProps.interface";

export default (blocks?: BLOCK_TYPE[]): AnchorMenuLink[] => {
    const result: AnchorMenuLink[] = [];

    if (blocks && blocks.length > 0) {
        blocks.forEach(block => {
            if (block?.settings.anchorMenuLabel) {
                const anchorIdentifier = getAnchorIdentifier(block.content._contentType, block.settings.anchorMenuLabel);

                result.push({
                    id: anchorIdentifier,
                    label: block?.settings.anchorMenuLabel
                });
            }
        });
    }

    return result;
};